<template>
  <nav class="navbar">

    <div class="logo">
      <router-link :to="{ name: 'Home' }">
        <img :src="logo_img" class="logo-img">
      </router-link>
    </div>

    <div class="buttons-list">
      
      <div class="button">
        <img class="button-img" 
        :src="srcs.cameras_list" 
        @click="click_cameras_list()" >        
      </div>

      <div class="button">  
        <img class="button-img" 
        :src="srcs.src_archive" 
        @click="click_archive_active()" >
      </div>

      <div class="button">
        <img class="button-img" 
        :src="srcs.src_profile"  
        @click="click_profile_active()"
        >
      </div>

      <div class="button">  
        <img class="button-img" 
        :src="srcs.src_camera"  
        @click="click_camera_active()">
      </div>

      <div @click="logout" class="button">
        <router-link :to="{ name: 'Login' }">
          <img :src="menu_images.logout_img" class="button-img">
        </router-link>
      </div>
    </div>
  </nav>
  <hr class="line">
</template>

<script>

import logo_img from '../assets/images/navbar/logo.svg'

import cameras_list from '../assets/images/navbar/cameras_list.png'
import cameras_list_active from '../assets/images/navbar/cameras_list_active.png'
import camera from '../assets/images/navbar/camera.png'
import camera_active from '../assets/images/navbar/camera_active.png'
import profile from '../assets/images/navbar/profile.png'
import profile_active from '../assets/images/navbar/profile_active.png'
import archive from '../assets/images/navbar/archive.png'
import archive_active from '../assets/images/navbar/archive_active.png'
import logout_img from '../assets/images/navbar/logout.png'

export default {
  name: "NavbarComponent",

  data() {
    return {
      logo_img, 
      menu_images: {
        cameras_list_img: {
          id: 1,
          img: cameras_list, 
          active_img: cameras_list_active,
        },
        camera_img: {
          id: 2,
          img: camera, 
          active_img: camera_active
        },
        profile_img: {
          id:3,
          img: profile, 
          active_img: profile_active
        },
        archive_img: {
          id:4,
          img: archive, 
          active_img: archive_active
        },
        logout_img,
      },

      active_menu: '',

      cliced: true,
      for_check_menu: '',
      
      srcs: {
        cameras_list: '',
        src_profile: '',
        src_camera: '',
        src_archive: '',
      }
    }
  },

  created() {
    this.srcs.cameras_list = this.menu_images.cameras_list_img.img
    this.srcs.src_profile = this.menu_images.profile_img.img
    this.srcs.src_camera = this.menu_images.camera_img.img
    this.srcs.src_archive = this.menu_images.archive_img.img
  
  },

  methods: {
    logout() {
      sessionStorage.removeItem("auth_token");
      sessionStorage.removeItem("ge_sid");
    },

    click_cameras_list() {  
      this.for_check_menu = 'cameras_list'
      this.dynamyc_active_menu('cameras_list_menu')
      this.srcs.cameras_list = this.menu_images.cameras_list_img.active_img
      this.return_cliced()
      this.active_menu = this.menu_images.cameras_list_img
      this.active_menu['src'] = 'cameras_list'  
    },

    click_profile_active() {
      this.for_check_menu = 'src_profile'
      this.dynamyc_active_menu('profile_menu')
      this.srcs.src_profile = this.menu_images.profile_img.active_img
      this.return_cliced()
      this.active_menu = this.menu_images.profile_img
      this.active_menu['src'] = 'src_profile'
    },

    click_camera_active() {
      this.for_check_menu = 'src_camera'
      this.dynamyc_active_menu('camera')  
      this.srcs.src_camera = this.menu_images.camera_img.active_img
      this.return_cliced()
      this.active_menu = this.menu_images.camera_img
      this.active_menu['src'] = 'src_camera'
    },

    click_archive_active() {
      this.for_check_menu = 'src_archive'
      this.dynamyc_active_menu('archive')
      this.srcs.src_archive = this.menu_images.archive_img.active_img
      this.return_cliced()
      this.active_menu = this.menu_images.archive_img
      this.active_menu['src'] = 'src_archive'
    },

    return_cliced() {
      // console.log(this.for_check_menu)
      // console.log(this.active_menu['src'])
      if ((this.for_check_menu == this.active_menu['src']) || (!this.active_menu['src'])) {
        this.cliced = !this.cliced
        if (this.cliced) {
          // this.dynamyc_active_menu('')
          for (let a in this.srcs) {
            if (this.active_menu.src == a) {
              this.srcs[a] = this.active_menu.img   
              this.dynamyc_active_menu('')     
            }
          }
        }
      } else {
       
        for (let a in this.menu_images) {
          this.cliced = !this.cliced
          if (this.menu_images[a]['id'] === this.active_menu['id']) {
            for (let i in this.srcs) {
              if (this.menu_images[a]['src'] == i ) {
                this.srcs[i] = this.menu_images[a]['img']
                if (this.cliced) {
                  this.cliced = !this.cliced
                }
                
              }
            }
          }
        }
      }
    },

    dynamyc_active_menu(data) {
      this.$emit('active_menu', {
        menu: data
      })
    },

  },
};
</script>

<style scoped>

  .navbar {
    display: grid;
    margin-top: 10px;
    align-items: center;
    grid-template-columns: 1.5fr 1fr;
  }

  .logo-img {
    margin-left: 70px;
  }

  .buttons-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    gap: 25px;
    margin-right: 70px;
    justify-items: center;
    align-items: center;
  }

  .line { 
    border: none; 
    background-color: #808080;
    height: 3px;
  }

  .button {
    cursor: pointer;
  }

  @media (max-width: 700px) {

    .navbar {
      grid-template-columns: 1fr 1fr;
    }

    .logo-img {
      margin-left: 30px;
    }

    .buttons-list {
      margin-right: 30px;
    }

  }

  @media (max-width: 600px) {

    .navbar {
      margin-top: 25px;
      grid-template-columns: 1fr 1fr;
    }

    .logo-img {
      height: auto;
      width: 60%; 
      margin-left: 20px;
    }


    .button-img {
      height: auto;
      width: 150%;
      margin-right: 20px;
    }
  }

  @media (max-width: 500px) {

    .buttons-list {
      margin-right: 15px;
    }

    .logo-img {
      width: 80%; 
      margin-left: 10px;
    }

   .button-img {
      height: auto;
      width: 160%;
    }
  }
</style>
